import React from "react";
import "./Testimonials.css";

const Testimonials: React.FC = () => {
  return (
    <section className="testimonials">

      <div className="testimonial-header">
        <div>
          <p className="small-title">— Testimonials</p>
          <h2>
            What Our Customers <br />
            Say About Us
          </h2>
        </div>

        <div className="testimonial-right">
          <p>
            ROHIT REGAL VENTURE is delivering high-quality eco-friendly bags across India.
          </p>

          <button className="btn-light">Place Your Order</button>
        </div>
      </div>

      <div className="testimonial-grid">

        <div className="testimonial-card">
          <p>
            We’ve been sourcing jute bags for our retail store. The quality is excellent,
            durable, and eco-friendly.
          </p>
          <div className="user">
            <img src="https://i.pravatar.cc/40?img=1" alt="Ravi Sharma" />
            <div>
              <h4>Ravi Sharma</h4>
              <span>Retail Supplier, Mumbai</span>
            </div>
          </div>
        </div>

        <div className="testimonial-card">
          <p>
            Custom printing service is top-notch. Branding came out perfectly
            on all our canvas bags.
          </p>
          <div className="user">
            <img src="https://i.pravatar.cc/40?img=2" alt="Pooja Mehta" />
            <div>
              <h4>Pooja Mehta</h4>
              <span>Corporate Buyer, Delhi</span>
            </div>
          </div>
        </div>

        <div className="testimonial-card">
          <p>
            Affordable pricing with great quality. Highly recommended for bulk orders.
          </p>
          <div className="user">
            <img src="https://i.pravatar.cc/40?img=3" alt="Rahul Gupta" />
            <div>
              <h4>Rahul Gupta</h4>
              <span>Wholesale Trader, Kolkata</span>
            </div>
          </div>
        </div>

        <div className="testimonial-card">
          <p>
            Fast delivery and strong material. Nylon bags are very durable.
          </p>
          <div className="user">
            <img src="https://i.pravatar.cc/40?img=4" alt="Anita Verma" />
            <div>
              <h4>Anita Verma</h4>
              <span>Distributor, Hyderabad</span>
            </div>
          </div>
        </div>

        <div className="testimonial-card full">
          <p>
            We regularly order bulk bags for our business. Rohit Regal Venture
            provides consistent quality and timely delivery every time.
          </p>
          <div className="user">
            <img src="https://i.pravatar.cc/40?img=5" alt="Sandeep Patel" />
            <div>
              <h4>Sandeep Patel</h4>
              <span>Business Owner, Ahmedabad</span>
            </div>
          </div>
        </div>

      </div>

    </section>
  );
};

export default Testimonials;